/* Rosas Home · tela de satín 3D (Three r160 + GSAP), cargada bajo demanda.
   Colores pastel sutiles, luz suave, sin competir con el contenido:
   cada sección le indica un estado (hero / soft / edge / off). */
(function () {
  'use strict';
  function readConfig() {
    var el = document.getElementById('rr-cloth-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function canRender(cfg) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    if (navigator.deviceMemory && navigator.deviceMemory <= 2) return false;
    if (navigator.connection && navigator.connection.saveData) return false;
    if (matchMedia('(max-width: 768px)').matches && cfg.mobile === false) return false;
    try { var p = document.createElement('canvas'); if (!(p.getContext('webgl2') || p.getContext('webgl'))) return false; } catch (e) { return false; }
    return true;
  }
  var loaded = {};
  function loadScript(src) {
    if (loaded[src]) return loaded[src];
    loaded[src] = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = src; s.async = true; s.onload = res;
      s.onerror = function () { rej(new Error('rr-cloth: no cargó ' + src)); }; document.head.appendChild(s);
    });
    return loaded[src];
  }

  var NOISE = [
    'vec3 mod289(vec3 x){return x-floor(x*(1.0/289.0))*289.0;}',
    'vec4 mod289(vec4 x){return x-floor(x*(1.0/289.0))*289.0;}',
    'vec4 permute(vec4 x){return mod289(((x*34.0)+1.0)*x);}',
    'vec4 taylorInvSqrt(vec4 r){return 1.79284291400159-0.85373472095314*r;}',
    'float snoise(vec3 v){',
    '  const vec2 C=vec2(1.0/6.0,1.0/3.0);const vec4 D=vec4(0.0,0.5,1.0,2.0);',
    '  vec3 i=floor(v+dot(v,C.yyy));vec3 x0=v-i+dot(i,C.xxx);',
    '  vec3 g=step(x0.yzx,x0.xyz);vec3 l=1.0-g;vec3 i1=min(g.xyz,l.zxy);vec3 i2=max(g.xyz,l.zxy);',
    '  vec3 x1=x0-i1+C.xxx;vec3 x2=x0-i2+C.yyy;vec3 x3=x0-D.yyy;',
    '  i=mod289(i);vec4 p=permute(permute(permute(i.z+vec4(0.0,i1.z,i2.z,1.0))+i.y+vec4(0.0,i1.y,i2.y,1.0))+i.x+vec4(0.0,i1.x,i2.x,1.0));',
    '  float n_=0.142857142857;vec3 ns=n_*D.wyz-D.xzx;vec4 j=p-49.0*floor(p*ns.z*ns.z);',
    '  vec4 x_=floor(j*ns.z);vec4 y_=floor(j-7.0*x_);vec4 x=x_*ns.x+ns.yyyy;vec4 y=y_*ns.x+ns.yyyy;vec4 h=1.0-abs(x)-abs(y);',
    '  vec4 b0=vec4(x.xy,y.xy);vec4 b1=vec4(x.zw,y.zw);vec4 s0=floor(b0)*2.0+1.0;vec4 s1=floor(b1)*2.0+1.0;vec4 sh=-step(h,vec4(0.0));',
    '  vec4 a0=b0.xzyw+s0.xzyw*sh.xxyy;vec4 a1=b1.xzyw+s1.xzyw*sh.zzww;',
    '  vec3 p0=vec3(a0.xy,h.x);vec3 p1=vec3(a0.zw,h.y);vec3 p2=vec3(a1.xy,h.z);vec3 p3=vec3(a1.zw,h.w);',
    '  vec4 norm=taylorInvSqrt(vec4(dot(p0,p0),dot(p1,p1),dot(p2,p2),dot(p3,p3)));p0*=norm.x;p1*=norm.y;p2*=norm.z;p3*=norm.w;',
    '  vec4 m=max(0.6-vec4(dot(x0,x0),dot(x1,x1),dot(x2,x2),dot(x3,x3)),0.0);m=m*m;',
    '  return 42.0*dot(m*m,vec4(dot(p0,x0),dot(p1,x1),dot(p2,x2),dot(p3,x3)));',
    '}'
  ].join('\n');

  var VERT = NOISE + [
    '',
    'uniform float uTime; uniform float uAmp; uniform float uFreq; uniform float uSeed; uniform vec2 uSize; uniform float uGust;',
    'varying vec3 vN; varying vec3 vP; varying vec2 vUv;',
    'float disp(vec2 p){',
    '  float t = uTime*0.22;',
    '  float n = snoise(vec3(p*uFreq + uSeed, t));',
    '  n += 0.36*snoise(vec3(p*uFreq*2.1 + uSeed*3.3, t*1.3));',
    '  n += 0.12*snoise(vec3(p*uFreq*4.5 + uSeed*7.1, t*1.8));',
    '  n += 0.5*sin(p.x*2.9 + p.y*1.6 + t*2.0 + uSeed) * (0.35 + 0.65*p.y);',
    '  n += uGust * sin(p.y*6.0 - uTime*3.6 + p.x*2.0) * 0.5;',
    '  return n*uAmp;',
    '}',
    'void main(){',
    '  vUv = uv; vec3 p = position; float e = 0.015;',
    '  float h = disp(uv); float hx = disp(uv+vec2(e,0.0)); float hy = disp(uv+vec2(0.0,e));',
    '  p.z += h;',
    '  vec3 tx = vec3(e*uSize.x, 0.0, hx-h); vec3 ty = vec3(0.0, e*uSize.y, hy-h);',
    '  vN = normalize(mat3(modelMatrix)*normalize(cross(tx,ty)));',
    '  vec4 wp = modelMatrix*vec4(p,1.0); vP = wp.xyz;',
    '  gl_Position = projectionMatrix*viewMatrix*wp;',
    '}'
  ].join('\n');

  var FRAG = [
    'precision highp float;',
    'uniform vec3 uColor; uniform vec3 uSheen; uniform float uOpacity; uniform vec3 uCam; uniform vec3 uL1; uniform vec3 uL2;',
    'varying vec3 vN; varying vec3 vP; varying vec2 vUv;',
    'void main(){',
    '  vec3 N = normalize(vN); if(!gl_FrontFacing) N = -N;',
    '  vec3 V = normalize(uCam - vP);',
    '  vec3 L1 = normalize(uL1); vec3 L2 = normalize(uL2);',
    '  float d = 0.70 + 0.24*max(dot(N,L1),0.0) + 0.12*max(dot(N,L2),0.0);',
    '  vec3 H1 = normalize(L1+V); float s1 = pow(max(dot(N,H1),0.0), 36.0);',
    '  vec3 H2 = normalize(L2+V); float s2 = pow(max(dot(N,H2),0.0), 16.0)*0.4;',
    '  float fr = pow(1.0-max(dot(N,V),0.0), 3.0);',
    '  vec3 col = uColor*d + uSheen*(s1+s2)*0.45 + vec3(1.0)*fr*0.14;',
    '  col = mix(col, vec3(1.0), 0.06);',
    '  float ex = smoothstep(0.0,0.10,vUv.x)*smoothstep(1.0,0.90,vUv.x);',
    '  float ey = smoothstep(0.0,0.10,vUv.y)*smoothstep(1.0,0.90,vUv.y);',
    '  float g = fract(sin(dot(vUv*vec2(1234.0,987.0), vec2(12.9898,78.233)))*43758.5453)*0.018;',
    '  gl_FragColor = vec4(col+g, uOpacity*ex*ey);',
    '}'
  ].join('\n');

  var STATES = {
    hero: { op: 1.0, spread: 0.0, amp: 1.0, z: 0 },
    soft: { op: 0.72, spread: 0.55, amp: 0.75, z: -0.6 },
    edge: { op: 0.5, spread: 1.15, amp: 0.7, z: -1.0 },
    off:  { op: 0.12, spread: 1.4, amp: 0.5, z: -1.6 }
  };

  function boot(cfg) {
    var canvas = document.querySelector('canvas.rr-cloth');
    if (!canvas || canvas.dataset.rrBooted === '1') return;
    canvas.dataset.rrBooted = '1';
    var isMobile = matchMedia('(max-width: 768px)').matches;
    var intensity = (cfg.intensity || 60) / 60;
    var C1 = cfg.c1 || '#F6F1EA', C2 = cfg.c2 || '#F3DCE0', C3 = cfg.c3 || '#E4DCEE';

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: !isMobile, powerPreference: 'high-performance' });
    renderer.setPixelRatio(Math.min(devicePixelRatio, isMobile ? 1.25 : 1.6));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(38, 1, 0.1, 100);
    camera.position.set(0, 0, 7.5);
    var group = new THREE.Group(); scene.add(group);

    function sheet(o) {
      var seg = isMobile ? 40 : 88;
      var geo = new THREE.PlaneGeometry(o.w, o.h, seg, Math.round(seg * o.h / o.w));
      var mat = new THREE.ShaderMaterial({
        vertexShader: VERT, fragmentShader: FRAG, transparent: true, side: THREE.DoubleSide, depthWrite: false,
        uniforms: {
          uTime: { value: 0 }, uAmp: { value: o.amp * intensity }, uFreq: { value: o.freq }, uSeed: { value: o.seed },
          uSize: { value: new THREE.Vector2(o.w, o.h) }, uGust: { value: 0 },
          uColor: { value: new THREE.Color(o.color) }, uSheen: { value: new THREE.Color(o.sheen || '#ffffff') },
          uOpacity: { value: o.opacity }, uCam: { value: camera.position },
          uL1: { value: new THREE.Vector3(-0.6, 0.9, 1.0) }, uL2: { value: new THREE.Vector3(0.9, -0.2, 0.7) }
        }
      });
      var m = new THREE.Mesh(geo, mat);
      m.position.set(o.x, o.y, o.z); m.rotation.set(o.rx, o.ry, o.rz);
      m.userData = { base: { x: o.x, y: o.y, z: o.z, rx: o.rx, ry: o.ry, rz: o.rz }, dir: o.dir, amp: o.amp * intensity, opacity: o.opacity, drift: o.drift };
      group.add(m); return m;
    }
    var S = [
      sheet({ w: 8.2, h: 5.6, x: 0.3, y: -0.5, z: -1.4, rx: -0.32, ry: 0.10, rz: -0.06, amp: 0.5, freq: 1.05, seed: 1.3, color: C1, opacity: 0.94, dir: [0.2, -1.1], drift: 0.6 }),
      sheet({ w: 5.4, h: 3.8, x: 3.3, y: 1.5, z: 0.3, rx: -0.2, ry: -0.5, rz: 0.32, amp: 0.36, freq: 1.5, seed: 4.2, color: C2, sheen: '#fff5f6', opacity: 0.9, dir: [1.4, 0.7], drift: 1.0 }),
      sheet({ w: 4.6, h: 3.2, x: -3.5, y: -1.7, z: 1.0, rx: 0.28, ry: 0.55, rz: -0.38, amp: 0.3, freq: 1.8, seed: 8.8, color: C3, sheen: '#f8f4ff', opacity: 0.86, dir: [-1.4, -0.6], drift: 1.2 })
    ];
    if (!isMobile) S.push(sheet({ w: 9.5, h: 6.4, x: -1.2, y: 1.4, z: -4.2, rx: -0.5, ry: -0.15, rz: 0.18, amp: 0.62, freq: 0.85, seed: 12.5, color: '#FBF8F3', opacity: 0.5, dir: [-0.6, 1.2], drift: 0.4 }));

    var state = { op: 1, spread: 0, amp: 1, z: 0 }, target = STATES.hero, scrollP = 0, scrollS = 0;
    var mouse = { x: 0, y: 0 }, sm = { x: 0, y: 0 }, velocity = 0, gust = 0, lastY = scrollY, lastT = performance.now();
    addEventListener('pointermove', function (e) { mouse.x = (e.clientX / innerWidth - 0.5) * 2; mouse.y = (e.clientY / innerHeight - 0.5) * 2; }, { passive: true });
    var pw = document.querySelector('.page-wrapper');
    var scroller = (pw && pw.scrollHeight > pw.clientHeight + 10) ? pw : null;
    function sTop() { return scroller ? scroller.scrollTop : scrollY; }
    function sMax() { return Math.max(scroller ? (scroller.scrollHeight - scroller.clientHeight) : (document.documentElement.scrollHeight - innerHeight), 1); }
    lastY = sTop();
    (scroller || window).addEventListener('scroll', function () {
      var now = performance.now(), y = sTop(); velocity = (y - lastY) / Math.max(now - lastT, 1) * 16; lastY = y; lastT = now;
      scrollP = Math.min(y / sMax(), 1);
    }, { passive: true });

    window.RRCloth = {
      setState: function (name) {
        var t = STATES[name] || STATES.soft;
        if (window.gsap) gsap.to(state, { op: t.op, spread: t.spread, amp: t.amp, z: t.z, duration: 1.6, ease: 'power2.inOut', overwrite: true });
        else target = t;
      }
    };
    function resize() { renderer.setSize(innerWidth, innerHeight, false); camera.aspect = innerWidth / innerHeight; camera.updateProjectionMatrix(); }
    addEventListener('resize', resize); resize();

    var clock = new THREE.Clock(), elapsed = 0, running = true, alive = true, first = true;
    canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); alive = false; }, false);
    canvas.addEventListener('webglcontextrestored', function () { alive = true; resize(); requestAnimationFrame(frame); }, false);
    function frame() {
      if (!running || !alive) return;
      elapsed += clock.getDelta();
      if (!window.gsap) { state.op += (target.op - state.op) * 0.04; state.spread += (target.spread - state.spread) * 0.04; state.amp += (target.amp - state.amp) * 0.04; state.z += (target.z - state.z) * 0.04; }
      scrollS += (scrollP - scrollS) * 0.06;
      sm.x += (mouse.x - sm.x) * 0.04; sm.y += (mouse.y - sm.y) * 0.04;
      group.rotation.y = sm.x * 0.10 + scrollS * 0.35; group.rotation.x = -sm.y * 0.06 - scrollS * 0.18;
      gust += (Math.min(Math.abs(velocity) / 45, 1.0) - gust) * 0.08;
      camera.position.z = 7.5 + scrollS * 1.2 - state.z;
      for (var i = 0; i < S.length; i++) {
        var m = S[i], u = m.material.uniforms, b = m.userData.base, d = m.userData.dir, k = m.userData.drift;
        m.position.x = b.x + d[0] * state.spread * 2.6 + Math.sin(elapsed * 0.12 + i) * 0.25 - scrollS * d[0] * 0.8 * k;
        m.position.y = b.y + d[1] * state.spread * 2.0 + Math.cos(elapsed * 0.10 + i * 2.0) * 0.2 + scrollS * 1.4 * k;
        m.position.z = b.z - state.spread * 0.8;
        m.rotation.x = b.rx + scrollS * 0.5 * k; m.rotation.y = b.ry + scrollS * 0.6 * k * (i % 2 ? -1 : 1); m.rotation.z = b.rz + scrollS * 0.25 * k;
        u.uTime.value = elapsed; u.uGust.value = gust; u.uAmp.value = m.userData.amp * state.amp; u.uOpacity.value = m.userData.opacity * state.op;
      }
      renderer.render(scene, camera);
      if (first) { first = false; canvas.classList.add('is-ready'); }
      requestAnimationFrame(frame);
    }
    document.addEventListener('visibilitychange', function () { running = !document.hidden; if (running) { clock.getDelta(); requestAnimationFrame(frame); } });
    frame();
    // Estado inicial según la sección visible
    var hero = document.querySelector('[data-rr-cloth-state]');
    if (hero) window.RRCloth.setState(hero.dataset.rrClothState);
  }

  function start() {
    var cfg = readConfig();
    if (!cfg || !canRender(cfg)) return;
    var libs = cfg.libs || {};
    if (!libs.three || !libs.gsap) return;
    loadScript(libs.three).then(function () { return loadScript(libs.gsap); }).then(function () { boot(cfg); }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('canvas.rr-cloth')) start(); });
})();
